module.exports = __webpack_public_path__ + "static/img/image_toning.3848235.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home/image_toning.jpg
// module id = yFjC
// module chunks = 2